import React from "react";
import Sortable from 'react-sortablejs';
import {getUuidv4, generateNameFromLabel} from '../shared/form_attribute_utils';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {isValidInteger, isValidFloat, isBlank} from '../shared/form_attribute_utils';
import APP_CONSTANTS, { PLACEHOLDER_OPTION } from '../shared/constants/app_constants';
import CKEDITOR_CONFIG from '../shared/constants/ckeditor_config';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import OptionMetadaEditor from './OptionMetadataEditor';
import FormAttributeOptionEditor from './FormAttributeOptionEditor';

export default class FormAttributeFormEditor extends React.Component{
  constructor(props) {
    super(props);
    //validate options value based on form attribute value type
    let autosetFaName = false;
    //if name contains the word input OR has no id then set to true
    if ( !props.form_attribute.id  ){
      autosetFaName = true;
    } else if ( //label matches name in format and is not being used as a form_rule_attribute
      generateNameFromLabel( props.form_attribute.label) ==  props.form_attribute.name && 
      props.form_attribute.form_rule_attributes.length === 0 ){
      autosetFaName = true;
    }
    
    // name should not be editable if it is a source OR target for a rule
    let faNameEditable = true;
    const form_attribute = this.props.form_attribute;
    if ( form_attribute.hasOwnProperty('form_rule_attributes') && form_attribute.form_rule_attributes.length > 0 ){
      faNameEditable = false;
    }

    /**
     * value type should not be editable if it's a source for a rule
     * maybe we should allow changing from float to integer and back?
     */
    let optionsArr = [];
    if (form_attribute.options){
      optionsArr = form_attribute.options.map((option, index) => {
        const uuidVal = option.uuid ? option.uuid : getUuidv4();
        return {...option, uuid: uuidVal};
      });
    }

    let faState = {
      // calculation_formula: form_attribute.calculation_formula || undefined,
      display_options: form_attribute.display_options, // deprecated
      settings: form_attribute.settings,
      display_type: form_attribute.display_type || "text",
      default_value: form_attribute.default_value != undefined ? form_attribute.default_value : "",
      fa_name_autoset: autosetFaName,
      fa_name_editable: faNameEditable,
      fa_name_modified: false,
      float_precision: form_attribute.float_precision || undefined,
      hidden: form_attribute.hidden || false,
      hide_label_flag: form_attribute.hide_label_flag || false,
      keenform: this.props.keenform, // this never changes, should it be state?
      label: form_attribute.label || "",
      name: form_attribute.name || "",
      option_has_label: form_attribute.option_has_label,
      options: optionsArr,
      placeholder: form_attribute.placeholder || "",
      show_calculation_modal: false,
      show_default_value_cke_editor: true,
      rails_authenticity_token: this.props.rails_authenticity_token, // this never changes, should it be state?
      read_only: form_attribute.read_only || false,
      required: form_attribute.required || false,
      score_multiplier: form_attribute.score_multiplier,
      use_blank_placeholder_option: form_attribute.use_blank_placeholder_option || false, // should we just use settings?
      value_type: form_attribute.value_type || "text",
    };

    this.state = faState;
    this.regexForName = /^[a-zA-Z0-9_]+$/;    
    this.labelColClasses = "col-lg-4 col-md-12 responsive-editor-label-container";
    this.inputColClasses = "col-lg-8 col-md-12";
    this.labelClass = "dashboard-label-std";
    this.toggleAttributes = ['required','hidden','read_only'];
  }

  addNewOption = () => {
    const totalOptionCount = this.state.options.length;
    let newOptionValue;
    switch (this.state.value_type){
      case "integer":
      case "float":
        newOptionValue = totalOptionCount + 1;
        break;
      default:
        newOptionValue = `Option ${totalOptionCount+1}`;
    }
    const newOption = {
      value: newOptionValue,
      label: newOptionValue.toString(),
      position: totalOptionCount+1,
      id: undefined,
      uuid: getUuidv4(),
      delete: false,
      new: true
    };
    this.setState({
      options: this.state.options.concat(newOption)
    })
  }

  allOptionsAreValid = () => {
    const allOptionsAreValid = this.state.options.reduce( (returnVal, thisOpt) => {
      return (returnVal && this.validateOptionValuePerDataType(thisOpt) );
    }, true);
    return allOptionsAreValid;
  }

  defaultValueIsValid = () => {
    if ( isBlank(this.state.default_value) 
      || this.state.value_type === APP_CONSTANTS.VALUE_TYPES.TEXT
      || this.state.default_value === PLACEHOLDER_OPTION ){
      return true;
    } else if (this.state.value_type === APP_CONSTANTS.VALUE_TYPES.INTEGER){
      return isValidInteger(this.state.default_value);
    } else if (this.state.value_type === APP_CONSTANTS.VALUE_TYPES.FLOAT){
      return isValidFloat(this.state.default_value);
    } else {
      console.error('missing or invalid value type: ' + this.state.value_type);
      return true;
    }
  }

  deleteThisOption = (thisOption) => {
    let updatedOptions = this.state.options.map( (opt) => {
      opt.delete = thisOption.position === opt.position ? true : opt.delete;
      return opt;
    });
    this.setState({
      options: updatedOptions
    });
  }

  displayDefaultValueErrorMsg = () => {
    return <div className="invalid-feedback" style={{'marginLeft':'-15px'}}>this default value is not valid</div>;
  }

  hasOptions(){
    return !!["select","checkbox","radio"].find( item => item === this.state.display_type );
  }

  hasClickableOptions = () => {
    return [APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX, APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO].includes(this.state.display_type);
  }

  renderDefaultValueInput = () => {
    switch(this.state.display_type){
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXT:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXTAREA:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.NUMBER:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.EMAIL:
        return (<div className="form-group row">
          <div className={`${this.labelColClasses}`}>
            <label className={`${this.labelClass}`} forhtml="form_attribute_default_value">Default value:</label>
          </div>
          <div className={`${this.inputColClasses}`}>
            <input
              className={`form-control ${ this.defaultValueIsValid() ? undefined : 'error is-invalid'}`}
              type="text"
              value={this.state.default_value}
              name="form_attribute[default_value]"
              id="form_attribute_default_value"
              onChange={(event) => {this.setState({default_value: event.target.value})}} />
              { this.defaultValueIsValid() ? undefined : this.displayDefaultValueErrorMsg() }
          </div>
        </div>);
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO:
        let placeholderOptionLabel = (this.state.placeholder);
        if (this.state.display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO) {
          placeholderOptionLabel = "<no radio button selected>";
        }
        return (
          <div className="form-group row">
            <div className={`${this.labelColClasses}`}>
              <label className={`${this.labelClass}`}>Default value:</label>
            </div>
            <div className={`${this.inputColClasses}`}>
              <select
                className="form-control" 
                value={this.state.default_value}
                onChange={(event) => {this.setState({default_value: event.target.value})}}
                name="form_attribute[default_value]"
                id="form_attribute_default_value">
              {this.state.use_blank_placeholder_option === false
                ? undefined
                : <option value={PLACEHOLDER_OPTION}>{placeholderOptionLabel}</option> }
              {this.state.options.map((option) => {
                return (<option 
                  key={option.uuid} 
                  value={option.value}>{option.value}
                </option>);
              })}
              </select>
            </div>
          </div>);
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX:
        // TODO: currently not availbe for checkbox/multiselect
        return undefined;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.DATEPICKER:
        // TODO: not available for datepicker yet
        return undefined;
      case 'static_text': //TODO: to be replaced
      case 'static_html':
        return this.renderDefaultValueForStaticHtml();
      case 'rating_scale':
        console.warn('this is under construction');
        return undefined;
      default:
        console.error('invalid display type for default value', this.state.display_type);
        return undefined;
    }
  }

  updateDisplayType = (event) => {
    const newDisplayTypeValue = event.target.value;
    let newState = {
      display_type: newDisplayTypeValue 
    };

    // if display type is anything other than text then set value type to text
    if (newDisplayTypeValue != "text") {
      newState.value_type = "text"
    };
    this.setState(newState);
  }

  renderDefaultValueForStaticHtml = () => {
    const form_attribute = this.props.form_attribute;
    const textareaClass = this.state.show_default_value_cke_editor ? 'd-none' : 'form-control';
    const registerEventRow =  this.state.show_default_value_cke_editor ? 'd-none' : '';
    return (
      <React.Fragment>

        <div className="form-group row">
          <div className={`${this.labelColClasses}`}>
            <label className={`${this.labelClass}`}>Static Text/HTML to be displayed</label>
          </div>
          <div className={`${this.inputColClasses}`}>
            { this.state.show_default_value_cke_editor ? 
              <CKEditor
                editor={ ClassicEditor }
                config={ CKEDITOR_CONFIG }
                data={this.state.default_value}
                onChange={ ( event, editor ) => {
                  const data = editor.getData();
                  this.setState( { default_value: data });
                } } /> : undefined
            }
            <textarea
              type="text"
              name="form_attribute[default_value]"
              className={textareaClass}
              rows="15"
              value={this.state.default_value}
              onChange={ (event) => { 
                this.setState({ default_value: event.target.value});
              }} />
            <button 
              type="button"
              className="btn btn-primary"
              onClick={() => {
                this.setState({show_default_value_cke_editor: !this.state.show_default_value_cke_editor })
            }}>toggle CK Editor</button>
          </div>
        </div>

        <div className={`form-group row ${registerEventRow}`}>
          <div className={`${this.labelColClasses}`}>
            <label className={`${this.labelClass}`}>register click events?</label>
          </div>
          <div className={`${this.inputColClasses}`}>
            <input type="hidden" name="form_attribute[register_click_events_on_html]" value="0" />
            <input 
              type="checkbox"
              className="form-control"
              value="1"
              defaultChecked={form_attribute.register_click_events_on_html}
              name="form_attribute[register_click_events_on_html]" />
          </div>
          <div className="col-12 badge bg-warning">*this is for an experimental feature</div>
        </div>

      </React.Fragment>);
  }

  renderOptionInputs = (option, index) => {
    const displayClass = option.delete ? "deleted" : "visible";
    const valueIsValid = this.validateOptionValuePerDataType(option);
    // get array of all the options EXCEPT option at index
    const allOptionsExceptThis = this.state.options .filter((option, i) => {
      return (option.delete !== true && i !== index);
    });
    // check to see if this value is already in there
    const valueIsUnique = !(allOptionsExceptThis.find(opt => opt.value === option.value));
    const validOptionClass = this.validateOptionValuePerDataType(option) && valueIsUnique ? "valid" : "invalid";
    return (
      <div key={option.uuid} className={`option option-draggable-container ${displayClass} ${validOptionClass}`} data-id={option.uuid}>
        <div className="option-essentials-container">
          <FormAttributeOptionEditor
            updateOptionValue={this.updateOptionValue}
            validateOptionValuePerDataType={this.validateOptionValuePerDataType}
            form_attribute={this.state}
            metadata_types={this.props.form_attribute.metadata_types}
            show_scoring_input={this.props.keenform.use_simple_scoring}
            option={option}
            index={index} />
          <div className="option-controls-container">
            <button type="button" className="btn btn-danger btn-circle-sm btn-sm btn-no-margin btn-no-padding" onClick={() => {this.deleteThisOption(option)}}>
              <i className="fas fa-times"></i>
            </button>
            <div className="drag-handle drag-handle-option-editor drag-handle-background">&nbsp;</div>
          </div>
        </div>

        <OptionMetadaEditor 
          option={option}
          option_index={index}
          form_attribute={this.props.form_attribute}
          keenform={this.props.keenform} />
        { valueIsValid ? undefined : <div className="alert alert-danger option-alert" role="alert">invalid per value type</div> }
        { valueIsUnique ? undefined : <div className="alert alert-danger option-alert" role="alert">each value must be unique</div> }
      </div>);
  }

  renderOptions() {
    const self = this;
    const hasDeletedOption = this.state.options.reduce( (hasDeleted, option) => {
      return hasDeleted || option.delete;
    }, false);
    const isSingleSelect = [APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT, APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO].includes(this.state.display_type);
    let labelForUseBlankPlaceholder = "Show blank option?";
    if (this.state.display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO){
      labelForUseBlankPlaceholder = "Radio input defaults to none";
    }
    const classForBlankOption = (this.state.use_blank_placeholder_option && this.state.display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT) ? 'show' : 'd-none';
    return (
    <div className="form-group row">
      <div className={`options-container ${this.labelColClasses}`}>
        <strong className="dashboard-label-std">Options:</strong>
      </div>
      <div className={`${this.inputColClasses}`}>
        <div className="px-3 mb-3">
          <div className="mb-1 px-2">
            <input name="form_attribute[option_has_label]" type="hidden" value="0" />
            <input 
              className="form-check-input"
              type="checkbox"
              value="1"
              checked={this.state.option_has_label}
              name="form_attribute[option_has_label]"
              id="form_attribute_option_has_label"
              onChange={(event) => { this.setState({option_has_label: event.target.checked})}} />
            <label className="font-weight-bold form-check-label">Show separate labels for options?</label>
          </div>
          <div className="mb-1 px-2">
            <input type="hidden" name="form_attribute[randomize_options]" value="0" />
            <input 
              type="checkbox"
              value="1"
              defaultChecked={this.state.settings?.randomize_options}
              name="form_attribute[randomize_options]"
              id="form_attribute_randomize_options"
              className="form-check-input"
            />
            <label className="font-weight-bold form-check-label">Randomize options?</label>
          </div>
          {
            isSingleSelect &&
            <div className="mb-1 px-2">
                <input 
                  type="checkbox"
                  value="1"
                  checked={this.state.use_blank_placeholder_option}
                  name="form_attribute[use_blank_placeholder_option]"
                  id="form_attribute_use_blank_placeholder_option"
                  className="form-check-input"
                  onChange={(event) => { this.setUseBlankPlaceholderOption(event.target.checked) }} />
                <label className="font-weight-bold form-check-label">{labelForUseBlankPlaceholder}</label>
                <input type="hidden" name="form_attribute[use_blank_placeholder_option]" value={this.state.use_blank_placeholder_option ? "1" : "0"} />
              </div>
          }
          <div className={`mb-3 ${classForBlankOption}`}>
            <input 
              type='text'
              name='form_attribute[placeholder]' 
              placeholder='...enter blank option text here'
              value={this.state.placeholder}
              onChange={(event) => { this.setState({placeholder: event.target.value})}} />
            <label className="font-weight-bold p-2">blank option label value here</label>
          </div>
          { this.hasClickableOptions() &&
            <div className="form-group row">
              <label 
                forhtml="options orientation"
                className="col-form-label col-sm-6 dashboard-label-std">Options orientation:</label>
              <select className="form-control col-sm-6" 
                name="form_attribute[options_orientation]"
                defaultValue={this.state.settings?.options_orientation}>
                <option value="default">default</option>
                <option value="flex">flex</option>
                <option value="flexbox-2cols">2 columns</option>
                <option value="flexbox-3cols">3 columns</option>
              </select>
            </div>
          }
          { this.hasClickableOptions() &&
            <div className="form-group row">
              <label 
                forhtml="options orientation"
                className="col-form-label col-sm-6 dashboard-label-std">Option Label Orientation:</label>
              <select className="form-control col-sm-6" 
                name="form_attribute[option_label_orientation]"
                defaultValue={this.state.settings?.option_label_orientation}>
                <option value="default">default</option>
                <option value="below">below</option>
              </select>
            </div>
          }
        </div>

      </div>
      <div className="col-12">
        <Sortable
        options={{
          animation: 150,
          group: {
            name: 'optionsEditor',
            pull: false,
            put: true
          },
          handle: ".drag-handle"
        }}
        onChange={(order) => {
          this.sortOptions(order);
        }}>
        {self.state.options.map ((option,index) => {return self.renderOptionInputs(option, index) })}
        </Sortable>
        <button type="button" className="btn btn-outline-primary" onClick={this.addNewOption}>
          + Add option</button>
        { hasDeletedOption ? 
          <button type="button" className="btn btn-info btn-sm" onClick={this.undeleteAllOptions}>undelete all</button> 
          : undefined 
        }
      </div>
    </div>);
  }

  setToggleButtonAttribute(attributeName){
    let newState = {};
    this.toggleAttributes.forEach(thisAttributeName => {
      newState[thisAttributeName] = 
        (thisAttributeName === attributeName && this.state[attributeName] === false);
    });
    this.setState(newState);
  }

  setUseBlankPlaceholderOption(checked){
    let newState = {
      use_blank_placeholder_option: checked
    };
    // special case, if this is a radio button display type and checked is TRUE
    if (this.state.display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO && checked) {
      newState['default_value'] = PLACEHOLDER_OPTION;
    }
    this.setState(newState);
  }

  showFloatSpecificAttributes = () => {
    return (<React.Fragment>
      <div className={`${this.labelColClasses}`}>
        <label className={`${this.labelClass}`}>Precision (for float values):</label>
      </div>
      <div className={`${this.inputColClasses}`}>
        <input
          name='form_attribute[float_precision]'
          defaultValue={this.state.float_precision}
          className='form-control'
          min="1" 
          max="10"
          placeholder="maximum quantity of digits after decimal point"
          type='number' />
      </div>
    </React.Fragment>);
  }

  showInputsForEditableFA = () => {
    const editableInputs = [
      APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX,
      APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT,
      APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO,
      APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXT,
      APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXTAREA,
      APP_CONSTANTS.DISPLAY_TYPES_HTML.NUMBER
    ]
    return editableInputs.includes(this.state.display_type);
  }

  /**
   * determines if display as input is available
   * @returns boolean should show the display as input
   */
  canSetDisplayAs = () => {
    return this.canHideLabel();
  }

  /**
   * the hide label toggle switch should only be avaiable for inputs like text/select etc
   * do not show toggle switch for static html, 
   * @returns boolean - show the hide label toggle switch
   */
  canHideLabel = () => {
    const canEdit = this.showInputsForEditableFA();
    return (canEdit || this.state.display_type == APP_CONSTANTS.DISPLAY_TYPES_HTML.EMAIL);
  }

  canEditValueType = () => {
    // if display type is checkbox/radio/select then yes
    // else if display type is number then allow for changing
    // otherwise FALSE
    let valueTypeCanBeEdited = false;
    switch(this.state.display_type){
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.NUMBER:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT:
        valueTypeCanBeEdited = true;
        break;
      default:
        // don't allow editing
    }
    return valueTypeCanBeEdited;
  }

  sortOptions = (newOrder) => {
    let newOrderState = newOrder.map( (uuid) => {
      const thisOption = this.state.options.find( opt => opt.uuid === uuid);
      return thisOption;
    });
    this.setState({
      options: newOrderState
    });
  }

  toggleCalculationModal = () => {
    this.setState({show_calculation_modal: !this.state.show_calculation_modal});
  }

  updateLabel = (event) => {
    let newState = {
      label: event.target.value
    };
    if (this.state.fa_name_autoset && this.state.fa_name_modified === false){
      newState.name = generateNameFromLabel(newState.label);
    }
    this.setState(newState);
  }

  updateName = (event) => {
    this.setState({
      name: event.target.value,
      fa_name_modified: true
    })
  }

  updateOptionValue = (value, option) => {
    const optionsState = this.state.options.map( (opt) => {
      if (option.uuid === opt.uuid){
        opt.value = value;
      }
      return opt;
    });
    this.setState({
      options: optionsState
    });
  }

  undeleteAllOptions = () => {
    const allOptions = this.state.options.map( (option) => {
      option.delete = false;
      return option;
    });
    this.setState({
      options: allOptions
    });
  }

  // can we change this to send the entire option? 
  // and if the option has been deleted then ignore it?
  validateOptionValuePerDataType = (option) => {
    if (option.hasOwnProperty('delete') && option.delete === true) {
      return true;
    }
    const value = option.value;
    switch (this.state.value_type){
      case "integer":
        return isValidInteger(value);
      case "float":
        return isValidFloat(value);
      case "text":
        return (value && value.length > 0);
      default: // this should not happen
        console.error('invalid value per type: ' + this.state.value_type);
        return false;
    }
  }

  render() {
    //validate data for form attribute
    const form_attribute = this.props.form_attribute;
    const hasFormRules = (
      !!form_attribute
      && !!form_attribute.form_rule_attributes 
      && form_attribute.form_rule_attributes.length > 0);
    const allOptionsAreValid = this.state.options.reduce( (returnVal, thisOpt) => {
      return (returnVal && this.validateOptionValuePerDataType(thisOpt) );
    }, true);
    let allOptionsAreUnique = true;
    const nonDeletedOptions = this.state.options
    .filter(option => option.hasOwnProperty('delete') === false || option.delete !== true);
    nonDeletedOptions
    .forEach( ( thisOption ) => {
      if (allOptionsAreUnique){
        const matchArray = nonDeletedOptions.filter( opt => opt.value === thisOption.value);
        allOptionsAreUnique = matchArray.length === 1;
      }
    });
    const labelIsValid = (
      this.state.label.length > 0 && this.state.label.length <= 100
    ) || this.state.display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.STATIC_HTML;
    const nameLengthIsValid = ( this.state.name.length >= 1 && this.state.name.length <= 50)
    const nameIsAlphanumeric = this.regexForName.test(this.state.name);
    const startsWithLetter = /^[a-z]/i.test(this.state.name);
    const formIsValid = (allOptionsAreValid && 
      allOptionsAreUnique && 
      labelIsValid && 
      nameLengthIsValid &&
      nameIsAlphanumeric &&
      this.defaultValueIsValid() );
    // const isNumberType = [APP_CONSTANTS.VALUE_TYPES.INTEGER, APP_CONSTANTS.VALUE_TYPES.FLOAT ].includes(this.state.value_type);
    let valueTypeOptions = this.props.form_attribute_value_types;
    if ( hasFormRules ){ // FORM RULES EXIST, limit what you can do
      // allow numbers to be switched
      if ( [APP_CONSTANTS.VALUE_TYPES.INTEGER, APP_CONSTANTS.VALUE_TYPES.FLOAT ].includes(this.state.value_type) ){
        // allow for this to be swtiched from integer to float and vice versa
        valueTypeOptions = [APP_CONSTANTS.VALUE_TYPES.INTEGER, APP_CONSTANTS.VALUE_TYPES.FLOAT ];
      } else { //restrict changing value type
        valueTypeOptions = [this.state.value_type];
      }
    } else {
      // TODO: clean this up, it's terrible code
      switch(this.state.display_type) {
        case APP_CONSTANTS.DISPLAY_TYPES_HTML.NUMBER:
          // allow numbers to be changed
          valueTypeOptions = [APP_CONSTANTS.VALUE_TYPES.INTEGER, APP_CONSTANTS.VALUE_TYPES.FLOAT ];
          break;
        case APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX:
        case APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT:
        case APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO:
          // allow anything except date
          valueTypeOptions = this.props.form_attribute_value_types.filter(type => type != "date");
          break;
        case APP_CONSTANTS.DISPLAY_TYPES_HTML.EMAIL:
          valueTypeOptions = [APP_CONSTANTS.VALUE_TYPES.TEXT];
        default:
          // leave as is
      }
    }
    
    // options for form attribute types
    let formAttributeDisplayTypes = this.props.form_attribute_display_types;
    const textDisplayTypes = [APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXT, APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXTAREA, APP_CONSTANTS.DISPLAY_TYPES_HTML.EMAIL];
    const singleSelectDisplayTypes = [ APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT, APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO];
    const selectableTypes = singleSelectDisplayTypes.concat([APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX]);

    // FA has an id, so only allow for limited editing
    if (!!this.props.form_attribute.id) {
      if ( textDisplayTypes.includes(this.props.form_attribute.display_type) ){ 
        // text/textarea is interchangable NO MATTER WHAT
        formAttributeDisplayTypes = textDisplayTypes;
      } else if ( selectableTypes.includes(this.props.form_attribute.display_type) && this.state.fa_name_editable) {
        // if selectable is not a source/target then allow for editing to another selectable
        formAttributeDisplayTypes = selectableTypes;
      } else if ( singleSelectDisplayTypes.includes(this.props.form_attribute.display_type) ){
        // make select/radio interchangable no matter what
        formAttributeDisplayTypes = singleSelectDisplayTypes;
      } else {
        // it should not change, i.e. HTML
        formAttributeDisplayTypes = [this.props.form_attribute.display_type];
      }
    }

    const faTypesWithDsecription = [
      APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM, 
      APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT, 
      APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT,
      APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.DATEPICKER
    ];
    const descriptionClass = faTypesWithDsecription.includes(this.props.form_attribute?.form_attribute_type) ? '' : 'd-none';

    const labelColClasses = "col-lg-4 col-md-12 responsive-editor-label-container";
    const inputColClasses = "col-lg-8 col-md-12";
    const labelClass      = "dashboard-label-std";
    return (
      <React.Fragment>
        { this.state.display_type == APP_CONSTANTS.DISPLAY_TYPES_HTML.STATIC_HTML 
          ? undefined
          : <div className="form-group row">
              <div className={`${labelColClasses}`}>
                <label className={`${labelClass}`} forhtml="form_attribute_label">Label:</label>
              </div>
              <div className={`col-sm-8 ${inputColClasses}`}>
                <input 
                  className={`form-control ${labelIsValid ? '' : 'error is-invalid'}`}
                  type="text"
                  maxLength="100"
                  value={this.state.label}
                  name="form_attribute[label]"
                  id="form_attribute_label"
                  onChange={this.updateLabel} />
                { this.state.label.length > 0 ? undefined 
                  : <div className="invalid-feedback" style={{'marginLeft':'-15px'}}>Label is required</div>
                }
                { this.state.label.length <= 100 ? undefined
                  : <div className="invalid-feedback" style={{'marginLeft':'-15px'}}>Label must be 100 characters or less</div>
                }
                { this.state.label.length === 100 
                  ? <div className="badge badge-warning" style={{'marginLeft':'-15px'}}>Label cannot exceed 100 characters</div>
                  : undefined
                }
              </div>
            </div>
        }
        <div className="form-group row">
          <div className={`${labelColClasses}`}>
            <label className={`${labelClass}`} forhtml="form_attribute_name">Name:</label>
          </div>
          <div className={`col-sm-8 ${inputColClasses}`}>
            <input
              className={`form-control ${(nameLengthIsValid && nameIsAlphanumeric && startsWithLetter) ? '' : 'error is-invalid'}`} 
              type="text" 
              value={this.state.name}
              id="form_attribute_name"
              name="form_attribute[name]"
              disabled={!this.state.fa_name_editable}
              readOnly={!this.state.fa_name_editable}
              maxLength="50"
              onChange={this.updateName} />
            { this.state.fa_name_editable ? undefined : <div className="mt-2 input-warning-message">form attribute name not editable because it is referenced in form rules</div> }
            <div className="invalid-feedback" style={{'marginLeft':'-15px'}}>
              <ul>
              { this.state.name.length < 1 ? <li>Name must be at least 1 character long</li> : undefined }
              { this.state.name.length > 50 ? <li>Name must be no greater than 50 characters long</li> : undefined }
              { nameIsAlphanumeric ? undefined : <li>Name can only contain letters, numbers, or _underscores</li> }
              { startsWithLetter ? undefined : <li>First letter of name must be a letter</li> }
              </ul>
            </div>
            { this.state.name.length === 50 ? <div className="badge badge-warning">Name cannot exceed 50 characters - limit reached</div> : undefined}
          </div>
        </div>
        <div className="form-group row">
          <div className={`${labelColClasses}`}>
            <label className={`${labelClass}`} forhtml="form_attribute_display_type">Display Type:</label>
          </div>
          <div className={`${inputColClasses}`}>
            <select className="form-control"
              value={this.state.display_type}
              name="form_attribute[display_type]" 
              id="form_attribute_display_type"
              disabled={ formAttributeDisplayTypes.length === 1}
              onChange={(event) => { this.updateDisplayType(event)}}>
              { formAttributeDisplayTypes.map(fadtype => {
                return (<option 
                  value={fadtype} 
                  key={fadtype}>
                    {fadtype.replace("_"," ")}
                  </option>);
              })}
            </select>
          </div>
        </div>
        { !this.canEditValueType() ? undefined :
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Value Type:</label>
            </div>
            <div className={`${inputColClasses}`}>
              <select className="form-control"
                value={this.state.value_type}
                name="form_attribute[value_type]"
                id="form_attribute_value_type"
                disabled={valueTypeOptions.length === 1}
                onChange={(event) => { this.setState({value_type: event.target.value})}}>
                { valueTypeOptions.map(valtype => {
                  return <option value={valtype} key={valtype}>{valtype}</option>;
                })}
              </select>
            </div>
          </div>
        }
        { this.state.value_type === APP_CONSTANTS.VALUE_TYPES.FLOAT 
          ? <div className="form-group row">{this.showFloatSpecificAttributes()}</div>
          : undefined 
        }
        { this.canSetDisplayAs() &&
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Display as:</label>
            </div>
            <div className="btn-group" role="group" aria-label="form-attribute-display-values">
              { this.toggleAttributes.map(attribute => {
                const buttonClasses = this.state[attribute] ? 'btn btn-info' : 'btn btn-light';
                return (<button 
                    type="button"
                    key={`display-${attribute}`}
                    className={buttonClasses}
                    onClick={ () => { this.setToggleButtonAttribute(attribute) } }>
                    {attribute.toUpperCase().replace("_"," ")}
                  </button>);
              })}
              { this.toggleAttributes.map((attributeName) => {
                const attrName = `form_attribute[${attributeName}]`,
                  attrVal = this.state[attributeName] ? 1 : 0;
                return (<input key={attributeName} type='hidden' name={attrName} value={attrVal} />);
              })}
            </div>
          </div>
        }
        {
          this.state.read_only &&         
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Read only format:</label>
            </div>
            <div className={`${inputColClasses}`}>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="form_attribute[read_only_display_format]"
                  id="form_attribute_read_only_display_format"
                  value="default"
                  defaultChecked={this.state.settings?.read_only_display_format != "formatted_text"} />
                <label className="form-check-label">default format (as read only input)</label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="form_attribute[read_only_display_format]"
                  id="form_attribute_read_only_display_format"
                  value="formatted_text"                   
                  defaultChecked={this.state.settings?.read_only_display_format === "formatted_text"} />
                <label>plain/formatted text</label>
              </div>
            </div>
          </div>
        }
        <div className="form-group row">
          <div className={`${labelColClasses}`}>
            <label className={`${labelClass}`}>Order (position):</label>
          </div>
          <div className={`${inputColClasses}`}>
            <input
              type="number"
              className="form-control"
              name="form_attribute[position]"
              id="form_attribute_position"
              defaultValue={this.props.form_attribute.position} />
          </div>
        </div>
        { this.canHideLabel() &&
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Hide Label?:</label>
            </div>
            <div className={`${inputColClasses}`}>
              <BootstrapSwitchButton 
                onlabel='Hide Label' 
                offlabel='Show Label'
                onstyle='danger'
                offstyle='light'
                width='200'
                size="lg"
                onChange={(checked) => {
                  this.setState({hide_label_flag: checked});
                }}
                checked={ this.state.hide_label_flag } />
              <input 
                type="hidden" 
                name="form_attribute[hide_label_flag]"
                value={( this.state.hide_label_flag === true ? 1 : 0 )} />
            </div>
          </div>
        }
        { this.props.form_attribute?.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM &&
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Placeholder:</label>
            </div>
            <div className={`${inputColClasses}`}>
              <input className="form-control"
                type="text" 
                value={this.state.placeholder} 
                name="form_attribute[placeholder]" 
                id="form_attribute_placeholder"
                maxLength="100"
                onChange={(event) => {this.setState({placeholder: event.target.value})}} />
              </div>
          </div>
        }
        {
          this.props.form_attribute?.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM &&
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Alignment:</label>
            </div>
            <div className={`${inputColClasses}`}>
              <select className="form-control" 
                name="form_attribute[input_alignment]"
                defaultValue={this.state.settings?.input_alignment}>
                  <option value="left">left</option>
                  <option value="right">right</option>
              </select>
            </div>
          </div>
        }
        {
          this.props.keenform.use_simple_scoring &&
          <div className="form-group row">
            <div className={`${labelColClasses}`}>
              <label className={`${labelClass}`}>Score multiplier:</label>
            </div>
            <div className={`${inputColClasses}`}>
              <input className="form-control"
                type="number"
                value={this.state.score_multiplier} 
                name="form_attribute[score_multiplier]" 
                id="form_attribute_placeholder"
                maxLength="100"
                onChange={(event) => {this.setState({score_multiplier: event.target.value})}} />
            </div>
          </div>
        }
        { this.renderDefaultValueInput({labelColClasses, inputColClasses}) }
        <div className={`form-group row ${descriptionClass}`}>
          <div className={`col-form-label ${labelColClasses}`}>
            <label className={`${labelClass}`} forhtml="form_attribute_description">Description:</label>
            <div>optional text/html to appear below label</div>
          </div>
          <div className={`${inputColClasses}`}>
            <textarea 
              className="form-control"
              type="text" 
              defaultValue={this.props.form_attribute.description} 
              name="form_attribute[description]" 
              id="form_attribute_description" />
          </div>
        </div>
        { this.hasOptions() && this.renderOptions({labelColClasses, inputColClasses}) }
        <div className="actions text-center">
          <button className="btn btn-primary btn-round" 
            disabled={formIsValid ? "" : "disabled"}>
              Save Form Attribute
            </button>
        </div>
      </React.Fragment>);
  }
}
